module.exports = __webpack_public_path__ + "static/media/study 220510.60cd33a1.png";